export class UpdateOrganizationUserRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "givenName",
            "baseName": "givenName",
            "type": "string",
            "format": ""
        },
        {
            "name": "orgRoleIds",
            "baseName": "orgRoleIds",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateOrganizationUserRequest.attributeTypeMap;
    }
    constructor() {
    }
}
